import styled from "styled-components";

export const SProjectLimitModal = styled.div`
  height: 95vh;
  width: 90vw;
  max-height: 720px;
  max-width: 1200px;
  background-color: var(--ui-background);
`;
